import { ReactNode } from 'react';
import styles from '../../Style/FeaturesModal.module.scss';

type FeatureSectionProps = {
  id: string;
  sectionRef: (el: HTMLElement | null) => void;
  children: ReactNode;
};

export function FeatureSection({ id, sectionRef, children }: FeatureSectionProps) {
  return (
    <section id={id} ref={sectionRef}>
      <div className={styles.sectionContainer}>{children}</div>
    </section>
  );
}
